const REGEX_DEFAULT_INPUTS = {
    PROJECT_NAME_REGEX: /^[\w\d\_\-]+$/g,
    PROJECT_AUTO_NAME_REGEX: /^[\w\d\_\-\=\:]+$/g,
    META_NAME_REGEX: /^[\a-z\d\_\-]+$/g,
    META_NAME_REMOVE: /[`~!@#$%^&*()|+\=?;:'",.<>\{\}\[\]\\\/]/gi,
    FILE_NAME_REGEX: /^[\w\d\_\-]+.[\w\d]+$/g
};

export default {
    MAX_PROJECT_INPUT: 100,
    MIN_PROJECT_INPUT: 1,
    ...REGEX_DEFAULT_INPUTS,
    MAX_FOLDER_PROPERTY_INPUT: 100,
    MAX_PROJECT_PROPERTY_INPUT: 20,
    MIN_PROJECT_PROPERTY_INPUT: 1,
    MIN_REFERENCE_IMAGES: 20,
    THRESHOLD_PERCENT_FOR_TRAINING: 50,
};

